import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import TransactionTable from "../PaymentsTables";
import DuesTable from "../PendingPaymentTable";
import NotFoundModel from "../../NotFoundModel";
import { useSelector } from "react-redux";
import { MdOutlineChevronRight } from "react-icons/md";
import { BoxHead, Underline } from "../../Styles/PageStyles";

const Passbook = ({
    transData,
    pendingData,
    summary,
    handleMarkAsPaid,
    setViewDetail,
    setSelectedData
}) => {
    const [selectedBox, setSelectedBox] = useState('totalPayments');
    const [selectedId, setSelectedId] = useState(1);
    const [selectedTable, setSelectedTable] = useState("totalPayments");
    const [securityData, setSecurityData] = useState();
    //const [selectedData, setSelectedData] = useState("");


    useEffect(() => {
        const securityData = transData.filter((tx) => tx.type === 43);
        setSecurityData(securityData);
    }, [transData]);

    const handleBoxClick = (type) => {
        setSelectedTable(type);
        setSelectedBox(type);
    };

    // const handleMarkPaidClose = () => {
    //     setIsMarkAsPaidVisible(false);
    // };

    // //------- Pay rent to Landlord -------
    // const markAsPaidFunction = async (values) => {
    //     return await axios.post(`${Config.apiUrl}/landlord/payment/init`, values, {
    //         headers: {
    //             "Content-Type": "application/json",
    //             authorization: `Bearer ${user.token}`,
    //         },
    //     });
    // };

    // const markAsPaidSuccess = (data) => {
    //     if (data?.data?.isSuccess === true) {
    //         if (data?.data?.link) {
    //             setIsMarkAsPaidVisible(false);
    //             window.open(data.data.link, "_blank", "noopener,noreferrer");
    //         }
    //     } else {
    //         toast.error(data?.data?.msg || "An Error Occured");
    //     }
    // };

    // const markAsPaidError = (data) => {
    //     toast.error(data?.response?.data?.msg || "An Error Occured");
    // };

    // const { isLoading: markAsPaidLoading, mutate: markAsPaidMutate } =
    //     useMutation(markAsPaidFunction, {
    //         onSuccess: markAsPaidSuccess,
    //         onError: markAsPaidError,
    //     });

    // //------- Mark As Paid Expense -------
    // const markPaidExpenseFunction = async (values) => {
    //     return await axios.post(`${Config.apiUrl}/expense/mark/paidx`, values, {
    //         headers: {
    //             authorization: "Bearer" + " " + user.token,
    //             "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    //         },
    //     });
    // };

    // const onMarkPaidExpenseSuccess = (data) => {
    //     if (data?.data?.isSuccess === true) {
    //         toast.success(data?.data?.msg || "Success");
    //         //getListMutate();
    //         setIsMarkAsPaidVisible(false);
    //     } else {
    //         toast.error(data?.data?.msg || "An Error Occured");
    //     }
    // };

    // const onMarkPaidExpenseError = (data) => {
    //     toast.error(data?.response?.data?.msg || "An Error Occured");
    // };

    // const { isLoading: markPaidExpenseLoading, mutate: markPaidExpenseMutate } =
    //     useMutation(markPaidExpenseFunction, {
    //         onSuccess: onMarkPaidExpenseSuccess,
    //         onError: onMarkPaidExpenseError,
    //     });

    return (
        <>
            <Wrapper>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        Passbook
                        <Underline />
                    </BoxTitle>
                </BoxHead>
                <ScrollCard style={{ scrollBehavior: "smooth", }}>
                    <Card selectedId={selectedId} index={1} onClick={() => {
                        setSelectedId(1);
                        handleBoxClick("totalPayments")
                    }
                    }>
                        <div >
                            <Value>
                                {summary?.collection || 0}
                            </Value>
                            <Label>
                                {"Total Payments"}
                                <MdOutlineChevronRight className="text-gray-300" size={24} />
                            </Label>
                        </div>
                    </Card>
                    <Card selectedId={selectedId} index={2} onClick={() => {
                        setSelectedId(2);
                        handleBoxClick("totalDues");
                    }
                    }>
                        <div >
                            <Value>
                                {summary?.totalPending || 0}
                            </Value>
                            <Label>
                                {"Total Dues"}
                                <MdOutlineChevronRight className="text-gray-300" size={24} />
                            </Label>
                        </div>
                    </Card>

                    <Card selectedId={selectedId} index={3} onClick={() => {
                        setSelectedId(3);
                        handleBoxClick("security")
                    }
                    }>
                        <div >
                            <Value>
                                {summary?.security || 0}
                            </Value>
                            <Label>
                                {"Security Paid"}
                                <MdOutlineChevronRight className="text-gray-300" size={24} />
                            </Label>
                        </div>
                    </Card>
                </ScrollCard>
            </Wrapper>

            {/* Table Section */}
            <div className="mt-4">
                {selectedTable === "totalPayments" && (
                    <>
                        {transData && (
                            <TableWrapper>
                                <TransactionTable
                                    apiData={transData || []}
                                    setSelectedData={setSelectedData}
                                    setViewDetail={setViewDetail}
                                />
                                {(transData?.length === 0) &&
                                    <NotFoundModel />}
                            </TableWrapper>
                        )}
                    </>
                )}
                {selectedTable === "totalDues" && (
                    <>
                        {pendingData && (
                            <TableWrapper>
                                <DuesTable
                                    apiData={pendingData}
                                    setSelectedData={setSelectedData}
                                    handleMarkAsPaid={(row) => handleMarkAsPaid(row)}
                                />
                                {(pendingData?.length === 0) && (
                                    <NotFoundModel msg="No Dues Pending" />
                                )}
                            </TableWrapper>
                        )}
                    </>
                )}

                {selectedTable === "security" && (
                    <>
                        {securityData && (
                            <TableWrapper>
                                <TransactionTable
                                    apiData={securityData || []}
                                    setSelectedData={setSelectedData}
                                    setViewDetail={setViewDetail}
                                />
                                {(securityData?.length === 0) &&
                                    <NotFoundModel />}
                            </TableWrapper>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

const Wrapper = tw.div`px-4 space-y-4 mt-2`;
const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  text-black`;
const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;

export default Passbook;
